import UserActivityToggler from './component';
import connect from './connect';

export default connect(UserActivityToggler);
